var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "header-row" }, [
        _c("nav", { staticClass: "navbar navbar-expand" }, [
          _c("ul", { staticClass: "navbar-nav align-items-center" }, [
            _vm.enableBackButton
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item ex-btn-left",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.backHandler.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm.user
              ? _c("li", { staticClass: "nav-item pl-2 user-info" }, [
                  _c("div", { staticClass: "user-info" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/sprite/icon-user@2x.png"),
                        height: "14"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "user-name" }, [
                      _vm._v(_vm._s(_vm.user.full_name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-info" }, [
                    _vm._v(_vm._s(_vm.user.company_name))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-info" }, [
                    _vm._v(_vm._s(_vm.user.branch))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item ex-btn-right" }, [
              _vm.enableButton
                ? _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.actionHandler.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.buttonName) }
                      })
                    ]
                  )
                : _vm._e()
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "nav-link", attrs: { href: "#" } }, [
      _c("i", { staticClass: "icon-back-red" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c("a", { staticClass: "nav-link ex-nav-logo", attrs: { href: "#" } }, [
        _c("img", {
          staticClass: "nav-link-logo",
          attrs: { src: require("@/assets/img/logo_jtb.png"), alt: "Logo" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79ad9114", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ad9114","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/sp/Header.vue
// module id = null
// module chunks = 